import { render } from "./OperBtnGroup.vue?vue&type=template&id=14e95f5b&scoped=true"
import script from "./OperBtnGroup.vue?vue&type=script&lang=js"
export * from "./OperBtnGroup.vue?vue&type=script&lang=js"

import "./OperBtnGroup.vue?vue&type=style&index=0&id=14e95f5b&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e95f5b"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QTooltip});
